/**
 * PWK power-cable selector.
 *
 * Wires the region blocks rendered by pwk-power-cable-select.liquid to the
 * .js-pwk-add-button on the same page section:
 *  - preselects a region from the customer's country (overridable),
 *  - updates the helper line + the button's target variant on change,
 *  - performs the add-to-cart with a "Power cable" line-item property and
 *    reopens the drawer, mirroring the bundled quick-add handler.
 *
 * Loaded once even if the snippet renders twice (guard below).
 */
(function () {
  if (window.__pwkCableInit) return;
  window.__pwkCableInit = true;

  // Country -> region. Mirrors PwkOrderSkuResolver / pwk-variant-resolver,
  // extended with the Type-G markets that ship with a UK cable.
  var COUNTRY_TO_REGION = {
    BE: 'EU', NL: 'EU', DE: 'EU', FR: 'EU', IT: 'EU', ES: 'EU', PT: 'EU',
    AT: 'EU', IE: 'EU', LU: 'EU', FI: 'EU', GR: 'EU', CZ: 'EU', PL: 'EU',
    HU: 'EU', SK: 'EU', SI: 'EU', EE: 'EU', LT: 'EU', LV: 'EU', BG: 'EU',
    RO: 'EU', MT: 'EU', CY: 'EU', HR: 'EU', DK: 'EU', SE: 'EU', IS: 'EU',
    NO: 'EU',
    US: 'US', CA: 'US', MX: 'US',
    GB: 'UK', SG: 'UK', HK: 'UK', AE: 'UK',
    CH: 'CH', LI: 'CH',
    AU: 'AU', NZ: 'AU'
  };

  function detectCountry() {
    if (window.cyclowaxCustomerCountry && COUNTRY_TO_REGION[window.cyclowaxCustomerCountry]) {
      return window.cyclowaxCustomerCountry;
    }
    try {
      var stored = localStorage.getItem('cyclowax_country');
      if (stored && COUNTRY_TO_REGION[stored]) return stored;
    } catch (e) { /* localStorage may be unavailable */ }
    if (window.Shopify && window.Shopify.country) {
      var sc = String(window.Shopify.country).toUpperCase();
      if (COUNTRY_TO_REGION[sc]) return sc;
    }
    if (navigator.language) {
      var parts = String(navigator.language).toUpperCase().split('-');
      if (parts.length > 1 && COUNTRY_TO_REGION[parts[1]]) return parts[1];
    }
    return 'BE';
  }

  function detectRegion() {
    return COUNTRY_TO_REGION[detectCountry()] || 'EU';
  }

  function initPicker(picker) {
    var radios = picker.querySelectorAll('.js-pwk-cable-option');
    if (!radios.length) return;

    var section = picker.closest('section') || document;
    var buttons = section.querySelectorAll('.js-pwk-add-button');

    function apply(radio) {
      var vid = radio.getAttribute('data-variant-id');
      var region = radio.value;
      for (var i = 0; i < buttons.length; i++) {
        if (vid) buttons[i].dataset.variantId = vid;
        buttons[i].dataset.powerCable = region;
        buttons[i].disabled = false;
      }
    }

    for (var i = 0; i < radios.length; i++) {
      radios[i].addEventListener('change', function () { apply(this); });
    }

    var region = detectRegion();
    var chosen = null;
    for (var j = 0; j < radios.length; j++) {
      if (radios[j].value === region) { chosen = radios[j]; break; }
    }
    if (!chosen) chosen = radios[0];
    chosen.checked = true;
    apply(chosen);
  }

  function initAddButton(btn) {
    btn.addEventListener('click', function () {
      var id = btn.dataset.variantId;
      if (!id) return;
      var region = btn.dataset.powerCable || detectRegion();
      var directCheckout = btn.dataset.directCheckout === 'true';

      btn.classList.add('is-loading');
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: id, quantity: 1, properties: { 'Power cable': region } }]
        })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (directCheckout) { window.location.href = '/checkout'; return; }
          btn.classList.remove('is-loading');
          btn.disabled = false;
          if (window.cartModal && window.cartModal.modal) window.cartModal.modal.show();
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        });
    });
  }

  function start() {
    var pickers = document.querySelectorAll('[data-pwk-cable]');
    for (var i = 0; i < pickers.length; i++) initPicker(pickers[i]);
    var btns = document.querySelectorAll('.js-pwk-add-button');
    for (var j = 0; j < btns.length; j++) initAddButton(btns[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
